<div class="part-list-wrapper">
  <div class="toolbar">
    <div class="search-filters">
      <div class="search-container">
        <span class="material-icons search-icon">search</span>
        <input
          type="text"
          class="search-input"
          placeholder="Search parts..."
          [(ngModel)]="partSearchQuery"
          (keyup.enter)="searchEnterPressed()"
        />
        <button
          type="button"
          class="btn btn-secondary"
          (click)="partSearchQuery.set('')"
        >
          Clear
        </button>
      </div>
    </div>
  </div>
  <div class="table-container">
    <table class="data-table">
      <thead>
        <tr>
          <th>Reference</th>
          <th>Description</th>
          <th>Group</th>
          <th>Price</th>
          <th style="width: 120px">Actions</th>
        </tr>
      </thead>
      @if (!searching()) {
        <tbody>
          @for (part of dataSource(); track part.id) {
            <tr>
              <td class="product-sku">{{ part.ref }}</td>
              <td class="product-name">{{ part.description }}</td>
              <td>{{ part.part_group_ref }}</td>
              <td class="right-align">{{ part.part_price }}</td>
              <td class="action-panel-container">
                <div class="row-actions">
                  @if (part.type == "composite") {
                    <a
                      class="btn btn-icon"
                      [routerLink]="['/parts/composites', part.id]"
                      ><span class="material-icons">edit</span></a
                    >
                  } @else {
                    <a class="btn btn-icon" [routerLink]="['/parts', part.id]"
                      ><span class="material-icons">edit</span></a
                    >
                  }
                  <button
                    class="btn btn-icon"
                    type="button"
                    (click)="delete(part.id)"
                  >
                    <span class="material-icons">delete</span>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      }
      @if (searching()) {
        <tbody>
          <tr>
            <td colspan="5">
              <mat-spinner></mat-spinner>
            </td>
          </tr>
        </tbody>
      }
    </table>
  </div>
  @if (!searching()) {
    <div class="pagination-container">
      <div class="pagination-info">
        {{ showingMessage }}
      </div>
      <div class="pagination-controls">
        <!--<select (change)="setPageSize($event)">
          <option value="15">15</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>-->
        <button
          type="button"
          class="pagination-btn"
          (click)="prevPage()"
          [disabled]="isFirstPage"
        >
          <span class="material-icons">chevron_left</span>
        </button>
        <span
          class="pagination-btn"
          (click)="setPage(1)"
          [ngClass]="isActivePage(1) ? 'active' : ''"
          >1</span
        >
        @if (curPage >= 5) {
          <span class="pagination-ellipsis">...</span>
        }
        @for (page of paginationPages; track page) {
          <span
            class="pagination-btn"
            (click)="setPage(page)"
            [ngClass]="isActivePage(page) ? 'active' : ''"
            >{{ page }}</span
          >
        }
        @if (curPage <= totalPages - 5) {
          <span class="pagination-ellipsis">...</span>
        }
        <span
          class="pagination-btn"
          (click)="setPage(totalPages)"
          [ngClass]="isActivePage(totalPages) ? 'active' : ''"
          >{{ totalPages }}</span
        >
        <button
          type="button"
          class="pagination-btn"
          (click)="nextPage()"
          [disabled]="isLastPage"
        >
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    </div>
  }
</div>
